module.exports = __webpack_public_path__ + "assets/img/2.06e9cbe3.gif";